import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/");
      return;
    }
    const exchange = async () => {
      try {
        const { data } = await axios.get(`${API}/auth/google/session`, {
          params: { session_id: match[1] },
          withCredentials: true,
        });
        window.history.replaceState(null, "", "/account");
        setUser(data);
        navigate("/account", { state: { user: data }, replace: true });
      } catch {
        navigate("/", { replace: true });
      }
    };
    exchange();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#07090e]">
      <Loader2 className="h-8 w-8 animate-spin text-amber-500" />
    </div>
  );
}
